import { gql } from 'graphql-request'

export const IMPORTAR_USUARIOS_QUERY = gql`
  query importarUsuariosQuery {
    importStatus {
      total
      done
      progress
      fileName
      status
    }
  }
`
